import { createAction } from '@ngrx/store';

export const NO_ACTION = '[Default] No Action';

export const noAction: any = createAction(NO_ACTION);
